import { CursorEditor } from '@slate-yjs/core'
import { useEffect, useRef } from 'react'
import { type Editor } from 'slate'
import { getCursorData } from './actions'

export function useMyCursor(editor: Editor) {
  const sentToRef = useRef<Editor | null>(null)

  useEffect(() => {
    if (!CursorEditor.isCursorEditor(editor) || sentToRef.current === editor)
      return

    let cancelled = false

    getCursorData().then((data) => {
      if (cancelled) return
      sentToRef.current = editor
      editor.sendCursorData(data)
    })

    return () => {
      cancelled = true
    }
  }, [editor])
}
